// extracted by mini-css-extract-plugin
module.exports = {"pill":"Pill_pill__uzW6P","vehicleSpec":"Pill_vehicleSpec__SxVBa","leftIcon":"Pill_leftIcon___SD96"};